import { t } from 'i18next';

import { DataTableColumn } from '~components/DataTable/dataTableColumn';
import { MatchKey } from '~hooks/useMatchKeys/models';

import MatchKeysCell from './MatchKeysCell';

export function matchKeysColumn<TRow extends { id: string }>(
  matchKeysByMatchableId: Map<string, MatchKey[]> | null,
): DataTableColumn<TRow> {
  return {
    field: 'matchKeys',
    headerName: t('administration.match_keys.title'),
    renderCell: (row) => (
      <MatchKeysCell
        matchKeys={
          matchKeysByMatchableId ? (matchKeysByMatchableId.get(row.id) ?? []) : null
        }
      />
    ),
  };
}
